export const REPORT_TYPES = {
  JOB_ROLE: 1,
  GROUP: 2,
  AMS_PERFORMANCE: 3,
  INDIVIDUAL_PERFORMANCE_TABLE: 4,
  INDIVIDUAL_PERFORMANCE_GRAPH: 5
};
